import React, { useState, useEffect } from "react";
import dashboardclasses from "../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ToastError } from "../../Components/utils/ToastMessage";
import { AiOutlineClose } from "react-icons/ai";
import swal from "sweetalert";
import { v4 as uuidv4 } from "uuid";
import { pincodeRegex } from "../../Components/utils/validations";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    const [base64, setbase64] = useState("");
    const watchFormData = watch();
    const [allstates, setStates] = useState([]);
    const [Cities, setCities] = useState([]);
    const getStates = () => {
        Services.getStates("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setStates(res.States);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const getcities = () => {
        Services.getcities("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setCities(res.Cities);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    useEffect(() => {
        getStates();
        getcities();
        if (props.editable) {
            reset({ ...props.editable });
        }
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };

    const onSubmit = (data) => {
        if (!props.editable) {
            Services.addpincode("POST", JSON.stringify(data), token)
                .then((res) => {
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(`/Pincodes?page=${1}`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories();

                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        } else {
            Services.updatepincode(
                "POST",
                JSON.stringify({ ...data, id: props.editable._id }),
                token
            )
                .then((res) => {
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(`/Pincodes?page=${1}`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories();

                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };
    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable ? "Update Pincode" : "Add Pincode"}
                        </h3>
                        <p>
                            {props.editable ? "Update Pincode" : "Add Pincode"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">State</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("statename", {
                                    required: "State Name is required",
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    Select State
                                </option>
                                {allstates.map((item) => (
                                    <option value={item.statename}>
                                        {item.statename}
                                    </option>
                                ))}
                            </select>
                            {errors?.couponfor && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.couponfor?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">State</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("cityname", {
                                    required: "City Name is required",
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    Select City
                                </option>
                                {Cities.map((item) => (
                                    <option value={item.cityname}>
                                        {item.cityname}
                                    </option>
                                ))}
                            </select>
                            {errors?.cityname && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.cityname?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Pincodes</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="text"
                                {...register("pincode", {
                                    required: "pincode  is required",
                                    pattern: {
                                        value: pincodeRegex,
                                        message:
                                            "Please enter a valid 6-digit Indian pincode",
                                    },
                                })}
                            />
                            {errors?.pincode && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.pincode?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div> */}

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Pincode"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
